import { Circle } from 'rc-progress';
import store from '../../../_services/store';
import labels from '../../../_translations/trainingview.json';
import navbarLabels from '../../../_translations/locals.json';
import { ReactComponent as LogoMolecule } from '../../../assets/svg/molecule.svg';
import { ReactComponent as LogoSymptome } from '../../../assets/svg/symptome.svg';
import { Header, PageTitle, ProgressBar } from '../../_ui';
import { COLORS } from '../../../constants';
import { CategoryLabel, Container, GeneralProgressContainer, GeneralProgressionLabel, LevelCard, LevelCardContainer, ReadProgressContainer } from './components';
import { useEffect } from 'react';
import { round } from '../../../_services/utils/utils';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../router/routes';

const TrainingPage = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    store.getMoleculesStats();
    store.getSymptomsStats();
    store.getLevels();
  }, [store]);

  const { levels } = store;
  const globalPercentage = round((levels?.globalPercentage || 0) * 100);
  const moleculesReadCount = round(store.moleculesStats.count / store.moleculesStats.total * 100);
  const symptomReadCount = round(store.symptomsStats.count / store.symptomsStats.total * 100);

  const navigateNextIndex = (level: { title?: string; desc?: string; id?: any; }) => {
    store.getQuizzes(level.id);
    store.setCurrentLevel(level);
    navigate(ROUTES.QUIZZES());
  };

  const CardLevels = levels?.LevelsPercentageResult.map(level =>
    <LevelCard
      key={`level_card_${level.level_id}`}
      onClick={() =>
        navigateNextIndex({
          title: `Niveau ${level.level_id}`,
          desc: level.level_name,
          id: level.level_id,
        })
      }
    >
      <Circle
        style={{ height: '60px', width: '60px', position: 'relative' }}
        percent={round(level.percentage * 100)}
        strokeWidth={8}
        strokeLinecap='round'
        strokeColor={COLORS.PRIMARY}
        trailWidth={8}
        trailColor={COLORS.PRIMARY + "33"}
      />
      <div>
        <p>{`Niveau ${level.level_id}`}</p>
        <p>{level.level_name}</p>
      </div>
      <div style={{ position: 'absolute', paddingLeft: '18px', display: 'flex', justifyContent: 'center' }}>
        <p style={{ textAlign: 'center' }}>{`${round(level.percentage * 100) || 0}%`}</p>
      </div>
    </LevelCard>
  ) || [];


  return (
    <div className="fadeIn">
      <Header bgUrl={"/images/bg-informations.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>
      </Header>

      {/* Vos connaissances */}
      <Container style={{marginBottom: '220px'}}>
        <CategoryLabel>{labels[store.currentLanguage].section.progress.title}</CategoryLabel>
        <GeneralProgressContainer>
          <GeneralProgressionLabel>{labels[store.currentLanguage].section.progress.bartitle}</GeneralProgressionLabel>
          <ProgressBar
            percentage={globalPercentage}
            height="12px"
            fillColor={COLORS.PRIMARY}
            backgroundColor={COLORS.PRIMARY + "33"}
          />
          <GeneralProgressionLabel>{`${globalPercentage}%`}</GeneralProgressionLabel>
        </GeneralProgressContainer>

        <LevelCardContainer>
          {CardLevels}
        </LevelCardContainer>

        {/* Vos lectures */}
        <CategoryLabel>{labels[store.currentLanguage].section.reading.title}</CategoryLabel>
        <div style={{ display: 'flex', flexDirection: 'row',flexWrap: 'wrap', gap: '10px', paddingBottom: '120px', width: '100%' }}>
          {/* Molecules */}
          <ReadProgressContainer style={{width: '100%'}}>
            <LogoMolecule fill={COLORS.PRIMARY} width={'55px'} height={'55px'} style={{ alignSelf: 'flex-start' }} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", width: '100%' }}>
              <GeneralProgressionLabel>{navbarLabels[store.currentLanguage].tabbar.labels.accueil}</GeneralProgressionLabel>
              <GeneralProgressionLabel>{`${isNaN(moleculesReadCount) ? 0 : moleculesReadCount}%`}</GeneralProgressionLabel>
            </div>
            
            <ProgressBar
              percentage={isNaN(moleculesReadCount) ? 0 : moleculesReadCount}
              height="12px"
              fillColor={COLORS.PRIMARY}
              backgroundColor={COLORS.PRIMARY + "33"}
            />
            
          </ReadProgressContainer>

          {/* Symptomes */}
          <ReadProgressContainer style={{width: '100%'}}>
            <LogoSymptome fill={COLORS.PRIMARY} width={'55px'} height={'55px'} style={{ alignSelf: 'flex-start' }} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", width: '100%' }}>
              <GeneralProgressionLabel>{navbarLabels[store.currentLanguage].tabbar.labels.tab1}</GeneralProgressionLabel>
              <GeneralProgressionLabel>{`${isNaN(symptomReadCount) ? 0 : symptomReadCount}%`}</GeneralProgressionLabel>
            </div>

            <ProgressBar
              percentage={isNaN(symptomReadCount) ? 0 : symptomReadCount}
              height="12px"
              fillColor={COLORS.PRIMARY}
              backgroundColor={COLORS.PRIMARY + "33"}
            />
          </ReadProgressContainer>
        </div>
      </Container>
    </div>
  )
})

export default TrainingPage;